import { Job } from '~extension/web2print/model/Job';

type OrderFormProps = {
  hookUrl: string;
  job: Job;
  orderMessage: string;
};

export function OrderForm({ hookUrl, job, orderMessage }: OrderFormProps) {
  return (
    <div className="p42-center">
      <h3 className="mb-2">Please click submit to order via SAP.</h3>

      <form action={hookUrl} method="post" id="sapForm">
        <input type="hidden" name="exec" value="SRM-TEST" readOnly />

        <input type="hidden" name="NEW_ITEM-LINE[1]" value="1" readOnly />
        <input type="hidden" name="NEW_ITEM-DESCRIPTION[1]" value={job.documentName} readOnly />
        <b>Please enter the amount of businesscards to order:</b>
        <input type="number" name="NEW_ITEM-QUANTITY[1]" defaultValue={100} />
        <input type="hidden" name="NEW_ITEM-UNIT[1]" value="EA" readOnly />
        <input type="hidden" name="NEW_ITEM-PRICE[1]" value="0.00" readOnly />
        <input type="hidden" name="NEW_ITEM-PRICEUNIT[1]" value="100" readOnly />
        <input type="hidden" name="NEW_ITEM-CURRENCY[1]" value="EUR" readOnly />
        <input type="hidden" name="NEW_ITEM-VENDORMAT[1]" value="" readOnly />
        <input type="hidden" name="NEW_ITEM-MATGROUP[1]" value="" readOnly />
        <input type="hidden" name="NEW_ITEM-EXT_PRODUCT_ID[1]" value={job.jobId} readOnly />

        <input type="hidden" name="NEW_ITEM-LONGTEXT_1:132[]" value={orderMessage} readOnly />

        <br />

        <button className="button c-button c-button--dark u-padding-horizontal-lg" type="submit">
          Submit to SAP
        </button>
      </form>

      <hr className="text-white my-3" />
      <a
        href="/sites/default/files/7152_UserManual_SAP_V15_2018.pdf"
        target="_blank"
        className="c-button c-button--dark"
      >
        Web2Print Manual PDF
      </a>

      <hr className="text-white my-3" />
      <div id="sapFormPrice">
        Choose the print method and quantity you require below. Please note the corresponding cost and enter it manually
        into SAP/SRM.
        <p>
          Branding with <strong>Linde logo only, one-sided:</strong>
        </p>
        <ul>
          <li>100 pcs € 16,35</li>
          <li>200 pcs € 21,90</li>
          <li>300 pcs € 27,45</li>
          <li>400 pcs € 33,00</li>
          <li>500 pcs € 38,55 </li>
          <li>1.000 pcs € 66,30</li>
        </ul>
        <p>
          Branding with <strong>Linde logo only, two-sided:</strong>
        </p>
        <ul>
          <li>100 pcs € 18,90</li>
          <li>200 pcs € 25,50</li>
          <li>300 pcs € 32,10</li>
          <li>400 pcs € 38,70</li>
          <li>500 pcs € 45,30</li>
          <li>1.000 pcs € 78,30</li>
        </ul>
        <p>
          Branding with <strong>Linde logo plus supplement, one-sided</strong> (Gas Partner, Gas & More, Gas & More
          Kontaktkarten, Unterbichler):
        </p>
        <ul>
          <li>100 pcs € 22,00</li>
          <li>200 pcs € 27,00</li>
          <li>300 pcs € 32,00</li>
          <li>400 pcs € 37,00</li>
          <li>500 pcs € 42,00</li>
          <li>800 pcs € 56,00 </li>
          <li>1.000 pcs€ 67,00</li>
        </ul>
        <p>
          Branding with <strong>Linde logo plus supplement, two-sided </strong> (Gas Partner, Gas & More, Unterbichler):
        </p>
        <ul>
          <li>100 pcs € 27,00</li>
          <li>200 pcs € 38,00</li>
          <li>300 pcs € 48,50</li>
          <li>400 pcs € 58,90</li>
          <li>500 pcs € 69,30</li>
          <li>800 pcs € 100,50</li>
          <li>1.000 pcs € 121,50</li>
        </ul>
      </div>
    </div>
  );
}
